const motionRoot = document.querySelector('[data-macfox-product-motion]');

if (motionRoot && motionRoot.dataset.macfoxProductMotionReady !== 'true') {
  motionRoot.dataset.macfoxProductMotionReady = 'true';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let activeImage = motionRoot.querySelector('.product_img_active');
  const riderHeight = motionRoot.querySelector('.cs-rider-height');
  let riderCopy = riderHeight?.textContent.trim() || '';
  let imageAnimationToken = 0;
  const animationRestartTokens = new WeakMap();

  const cancelClassAnimation = (element, className) => {
    if (!element) return;
    animationRestartTokens.set(element, (animationRestartTokens.get(element) || 0) + 1);
    element.classList.remove(className);
  };

  const restartClassAnimation = (element, className) => {
    if (!element || reduceMotion.matches) return;
    const token = (animationRestartTokens.get(element) || 0) + 1;
    animationRestartTokens.set(element, token);
    element.classList.remove(className);
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!element.isConnected || reduceMotion.matches || animationRestartTokens.get(element) !== token) return;
        element.classList.add(className);
      });
    });
  };

  const updateOptionAccessibility = () => {
    [motionRoot, ...document.querySelectorAll('.cs-atc-dialog')].forEach((scope) => {
      scope.querySelectorAll('.product_accessory_sku[role="button"]').forEach((candidate) => {
        candidate.setAttribute('aria-pressed', candidate.classList.contains('accessory_sku_active') ? 'true' : 'false');
        candidate.setAttribute('aria-disabled', candidate.classList.contains('sku_disabled') ? 'true' : 'false');
      });
    });
  };

  const animateActiveImage = (image) => {
    const token = ++imageAnimationToken;
    const play = () => {
      if (token !== imageAnimationToken || image !== motionRoot.querySelector('.product_img_active')) return;
      restartClassAnimation(image, 'mf-motion-image-enter');
    };

    if (image.complete) {
      if (image.naturalWidth > 0) play();
      return;
    }

    image.addEventListener('load', play, { once: true });
    image.addEventListener('error', () => image.classList.remove('mf-motion-image-enter'), { once: true });
  };

  motionRoot.addEventListener('click', (event) => {
    const option = event.target.closest('.product_accessory_sku');
    if (!option || option.classList.contains('sku_disabled')) return;

    updateOptionAccessibility();
    requestAnimationFrame(() => {
      updateOptionAccessibility();
      const nextImage = motionRoot.querySelector('.product_img_active');
      if (nextImage && nextImage !== activeImage) {
        cancelClassAnimation(activeImage, 'mf-motion-image-enter');
        activeImage = nextImage;
        animateActiveImage(nextImage);
      }

      if (riderHeight) {
        const nextCopy = riderHeight.textContent.trim();
        if (nextCopy !== riderCopy) {
          riderCopy = nextCopy;
          restartClassAnimation(riderHeight, 'mf-motion-update');
        }
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const option = event.target.closest('.product_accessory_sku[role="button"]');
    if (!option || (!motionRoot.contains(option) && !option.closest('.cs-atc-dialog'))) return;
    if (option.classList.contains('sku_disabled')) return;
    event.preventDefault();
    const dialog = option.closest('.cs-atc-dialog');
    const { position, value } = option.dataset;
    option.click();
    if (dialog) {
      requestAnimationFrame(() => {
        const replacement = [...dialog.querySelectorAll('.product_accessory_sku')].find((candidate) => (
          candidate.dataset.position === position && candidate.dataset.value === value
        ));
        replacement?.focus();
      });
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('.cs-sticky-atc .--sticky-add-cart')) return;
    requestAnimationFrame(updateOptionAccessibility);
  });

  updateOptionAccessibility();
  requestAnimationFrame(updateOptionAccessibility);

  reduceMotion.addEventListener?.('change', (event) => {
    if (!event.matches) return;
    imageAnimationToken += 1;
    motionRoot.querySelectorAll('.mf-motion-image-enter').forEach((image) => cancelClassAnimation(image, 'mf-motion-image-enter'));
    cancelClassAnimation(riderHeight, 'mf-motion-update');
  });
}
